import { TextField } from "@mui/material";

const IdEntry = ({ elementName, fieldLabel, startingValue, setResourceState, debug, marginTop, required }) => {
  return <TextField error={required && !startingValue}
    style={{ width: "20%", marginTop: marginTop || "12px" }}
    className="inputField" type='text' label={fieldLabel} size="small" variant='outlined'
    value={startingValue || ""}
    onChange={(e) => { setResourceState(prevState => { return { ...prevState, [elementName]: e.target.value }; }); }} />
};

export default IdEntry;